import styled, { css } from 'styled-components';
import media from '../../../utils/styling/media';

import Message from '../Message';

export const StyledMessage = styled(Message)`
  border: ${({ theme }) => theme.colors.error} 1px solid;

  background: ${({ theme }) => theme.colors.errorBackground};
`;

export const StyledMessageList = styled.div`
  position: relative;
  margin: 0;
  padding-left: 0;
`;

export const StyledMessageSeparator = styled.div<{ $color: string }>`
  display: inline-block;
  margin-top: .75em;
  margin-bottom: .75em;
  
  &:before {
    position: absolute;
    content: '';
    display: inline-block;
    width: 100%;
    border-top: ${({ $color }) => $color} 1px solid;
  }
`;

export const StyledMessageItem = styled.div<{useBullets: boolean; $color: string }>`
  margin: 0;

  ${({ useBullets }) => useBullets && css<{ $color: string }>`
    margin-left: 16px;
  `}
`;

export const StyledText = styled.span``;

export const StyledActions = styled.div<{align: 'left' | 'center' |'right'}>`
  margin-top: 16px;
  display: flex;
  justify-content: center;

  ${media.sm<{align: 'left' | 'center' |'right'}>`
    justify-content: ${({ align }) => align};
  `}
`;
